module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Daisies Are Forever")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#cnt1",
      "id": "ctn1"
    }
  }, [_vm._v("ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "txline"
  }), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EILIGENBEIL")]), _vm._v(", E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AST")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RUSSIA")])]), _vm._v(" "), _c('p', {
    staticClass: "tx3"
  }, [_c('i', [_vm._v("February 8, 1945")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("B")]), _vm._v("right red and orange explosions lit the dark, deep-winter evening. Gisela Cramer hugged herself to ward off the bitter chill. Her warm breath frosted the windowpane and with her fingernail she shaved a peephole. She didn’t know what she expected to see. Maybe the Russians surging over the hill.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("An icy shudder racked her. She couldn’t block out the sights and the sounds of the last time the Russians found her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Behind her Ella Reinhardt’s two small girls giggled as they played on the worn green-and-blue Persian rug that covered the hardwood floors. Gisela’s "), _c('i', [_vm._v("opa")]), _vm._v(" dozed in his sagging, overstuffed chair, his Bible open on his lap. His skin hung on his thin face. Every now and then he coughed and stirred, then settled back to sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Each day her grandfather grew weaker. His condition worried Gisela, especially since he refused to see a doctor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A Red Army mortar shell hit its target not far from them in town and rocked the earth beneath her feet. The vibrations almost buckled her legs. Her heart throbbed in her chest. How much longer could the German army hold off the Soviets? What would happen to them when they arrived?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_vm._v("Almost at the same instant, an urgent pounding began at the door, accompanied by Dietrich Holtzmann’s deep voice. “"), _c('i', [_vm._v("Herr")]), _vm._v(" Eberhart. Herr Eberhart.”")])]), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Not wanting Opa to have to get up, Gisela spun from the window, tiptoed over and around the children’s dolls and blocks, and answered the door.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The breathless older man stepped over the threshold. The wind had colored his cheeks. He pulled his red knit cap over his ears, gray hair sticking out of the bottom. “I had to warn you right away.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Gisela held out her hands to take their neighbor’s coat, but he shook his head. “I can’t stay.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Let me get you something hot to drink at least. Some ersatz coffee maybe?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Have a game of checkers with me, Dietrich. We can talk as we play.” Opa sat straighter in his chair.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I don’t have time. We’re leaving, Bettina and Katya and me. Tonight. Whoever is left in town is going west, as far and as fast as possible. By morning the Russians will pour in from the south. You need to come with us. All of you. Take the children and get out of here. It is too dangerous.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Gisela had feared this moment for many days. Though she had pleaded with her family to leave, they delayed. Opa’s health was too poor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Gisela peered at the girls, now clutching their dolls to their chests and staring at Herr Holtzmann with their big gray eyes. Another shudder ripped through her. She knew all too well the peril they would be in if they didn’t leave before the Red Army arrived.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Opa’s hands shook as he grasped the chair’s armrests to stand. “"), _c('i', [_vm._v("Ja")]), _vm._v(", it is time to leave. We knew it would come, though we prayed it wouldn’t.”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_vm._v("Her cousin Ella stepped into the living room from the tiny kitchen, wiping her cracked hands on a faded blue dish towel, then tucking a strand of blond hair behind her ear.")])]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("The cold wrapping itself around Gisela intensified. How would Opa make the trek? They had no car, no horse, only bicycles. “Are you sure they will be here by morning?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Herr Holtzmann nodded. “If you wait for daylight, it will be too late. Pack whatever you can and get out of here. My sisters and I are leaving within the hour.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Gisela rubbed her arms. “What about Opa?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her grandfather shook his head. She recognized the determination in the firm line of his mouth. He couldn’t be thinking about staying here. Surely not.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Herr Holtzmann pulled his red knit cap farther over his ears. “Go. Right now. Get out of this place and head west.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ella ushered their neighbor into the frigid night. “We will be ready in an hour.” She took a moment to lean against the door after she closed it, breathing in and out. Gisela followed her lead, willing her galloping heart to settle into a canter. Another nearby blast rocked the house, reverberating in her bones.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Closer. Closer. They were coming closer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In her memory, she heard those soldiers kick in the door. Heard screams. Gunshots.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She clutched her chest, finding it hard to breathe, and snapped back to the present.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They had to run.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("An hour. They would leave in an hour. She drew an unsteady breath and steeled herself. “We can’t let them catch us.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Deep sadness and fear clouded Ella’s face. “You leave.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Gisela took a step back. “What about you?”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_vm._v("“What about Opa? He will never survive the trip. He needs me. And the Red Cross is depending on me. With so many refugees ")]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_vm._v("already in the city, the "), _c('i', [_vm._v("DRK")]), _vm._v(" can’t do without anyone.” She squared her shoulders and straightened her spine.")])]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Gisela glanced at Annelies and Renate playing once more, now pulling a colorful tin train on a string. “What about the girls? They can’t stay.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I want you to take them.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Had Ella lost her mind? Gisela couldn’t leave her opa and her cousin here alone to face a horrible, certain fate. Those screams she had once heard rattled in her brain again. “"), _c('i', [_vm._v("Nein")]), _vm._v(". I won’t leave without you. Both of you. Let us get packed.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Opa stepped in front of her, his arms crossed. “Ella and I discussed this weeks ago, when the Russian offensive began. You will take the girls and go. She and I will remain here. When the fighting is over, we will join you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“If all of us don’t go, none of us will.” Gisela headed toward the kitchen. Ella grabbed her by the shoulder, her fingers digging into Gisela’s flesh. “You’re not listening to me. I am not going. And Opa can’t.” Annelies and Renate ran to their mother and clutched her leg.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ella lowered her voice. “I will help you get ready and give you whatever money I have, but you have to be the one to take my children. I have the nursing skills to take care of Opa. And when the war is over, this is where Frederick will come looking for me. If I’m not here, he won’t be able to locate me. "), _c('i', [_vm._v("Bitte, ")]), _vm._v("bitte, take my children to safety. Opa and I will join you as soon as possible.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Chilled to the core, Gisela bit her lip. The pleading, crying in Ella’s voice pinched her heart. Should she take the girls and leave her cousin and Opa behind? “You know what awaits you if you stay.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You have to do this. For my sake. Save my girls. Take them from here. It’s their only chance.”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_vm._v("The fluttering in Gisela’s stomach meant she would never see ")]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_vm._v("Ella again. Nor Opa. Her throat constricted, making speech difficult. “Think about this. Your girls need you. Their father is gone and you are all they have left. I’m not their mother. I’m not enough for them. You have a responsibility.”")])]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("The color in Ella’s fair face heightened. “And I have a vow to my husband. This isn’t easy for me to send my children west. Believe me, my heart is breaking. And your parents did it for you. I am asking you—begging you—to do this for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Thoughts whirled like a snowstorm through Gisela’s mind. How could she take care of the girls? Even if she got them to safety, what would happen to them after the war? Their mother would never come and their father would never find them, if he even survived.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And Opa. The Russians would not show mercy to an old, sick man.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ella drew Gisela’s stiff body close and whispered in her ear, her words laced with tears. “I trust you. I have faith in you. Bitte, for my sake, for the girls’ sakes, take them.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I will not separate them from their mother. If you don’t come with us, I won’t go either.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ella released her hold and Gisela fled up the steep wood stairs to her second floor bedroom. The pictures of Opa and "), _c('i', [_vm._v("Oma")]), _vm._v(" with their children rattled on the wall as another shell hit its mark. They had no time to waste.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The room had a sloped roof and was tiny, with little space not taken by the bed and the pine wardrobe. A small doily-covered bedside table held her Bible, a picture of "), _c('i', [_vm._v("Mutti")]), _vm._v(" and "), _c('i', [_vm._v("Vater")]), _vm._v(", and a photograph of her beloved sister, Margot.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Without thinking much, Gisela grabbed all of her underwear, a red-and-green plaid wool skirt, two blouses, and a gray sweater and stuffed them into a well-traveled pea-green suitcase. All of it donated by Ella when Gisela arrived here last fall.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_vm._v("She yanked the drawer pull of the nightstand so hard it shook. ")]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v("Fighting for breath and to hold back tears, she picked up her Bible, the one she had always kept here, and the photos and stuffed them into her suitcase.")])]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_c('i', [_vm._v("Hurry, hurry, hurry.")]), _vm._v(" The words pounded in her head in time to the pounding of her heart. What else must she take? Money.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A rusty coffee tin hidden in the back of her wardrobe held all the cash she had in the world. She withdrew it and removed the small wad of colorful "), _c('i', [_vm._v("reichsmarks")]), _vm._v(", counting them three times to make sure she knew what she had. Or didn’t have.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She folded the cash and slipped it into a pocket sewn on the inside of her dress, along with a handful of cigarettes from the tin. They were like gold, barter for whatever they needed. Anyone would sell anything for a cigarette.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She did much the same as she had two years ago when she traveled to East Prussia and to safety, away from her parents, away from the Allied bombs in Berlin. The war had caught up with her when she stayed with "), _c('i', [_vm._v("Tante")]), _vm._v(" Sonje and her cousins farther east in the country in Goldap.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And it had caught up again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('i', [_vm._v("Lord, please keep us safe. Let us escape. I can’t go through that torment again.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her hands shook as she picked up her heavy suitcase and headed for the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Moments later, Ella appeared carrying a small overnight case. Gisela released her breath in a whoosh. At least her cousin had made the only wise decision.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Gisela charged past Ella and down the hallway. “If you help Opa gather his things, I’ll pack what food we have, then change into something warmer. After I finish that, I will help you get the children ready.” Not waiting for Ella’s reply, Gisela made her way to the first level, the suitcase thumping down every step, Ella’s footfalls echoing behind her.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v("The empty kitchen cupboards reminded her of the “Old Mother Hubbard” nursery rhyme her mother had told her ages ago when they lived in California. They contained not much more than those of that fictional character.")])]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Gisela wrapped up what she could—a few loaves of bread, some potatoes and cabbages. She gathered vegetables canned last summer with produce from their garden and sticks of wurst. The sausages would travel well. When they ran out of food, they would have to buy what they needed until they depleted their cash.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She didn’t want to think about what would happen then.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Gisela returned to her room. She pulled on two pairs of cotton stockings, three pairs of wool socks, a pair of pants, a serviceable blue wool skirt, a blouse, and a red wool dress. On top, she layered her knee-length black wool coat, thankful that her weight loss enabled her to button it. Like Charlie Chaplin, she waddled to the girls’ pink-papered room to help Ella dress the girls. How would they ever walk in all of these clothes?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her cousin was getting Renate ready but again she didn’t speak as she tugged a wool sweater over her daughter’s head. As Gisela helped Annelies sit on the bed beside her sister and pull on two pairs of heavy wool socks, the child looked at her with round gray eyes. “Where are we going?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“On an adventure. Doesn’t that sound like fun?” Gisela willed her trembling fingers to tie the little shoe faster. “We will see different places and meet many different people. Perhaps we will get to ride on a train. Would you like that?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Annelies nodded, her blond curls bouncing. “I want to ride on a train.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her three-year-old sister refused to be left out of the fun. “I go on the train too.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Ja, Renate, you may go on the train too.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Hooray.” The girls bounced on their feather mattress.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("Ella gave Renate a stern glance. “You must sit still so I can get you dressed. It is going to be cold and you need to keep warm.” Cold didn’t quite capture the bone-chilling twenty-below Celsius temperature the thermometer recorded.")])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("They carried the girls downstairs because they couldn’t move well with the clothes they had on—their two coats each, their toboggan hats, and shoes with boots over them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Gisela stopped short when she saw Opa, dozing once more in his threadbare chair. He had not begun to prepare for the flight west. She shook him to wake him. “It’s time to leave. You must get dressed.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Opa opened his eyes, as blue as the East Prussian sky in summer. He patted her hand. “Gisela, my dear child, I cannot leave. You know that in your heart. Please go. Don’t make this more difficult than it is.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She knelt beside Opa and clasped his hands in hers. “How can I leave you?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You have a job to do. Get Ella’s "), _c('i', [_vm._v("kinder")]), _vm._v(" to safety. What happens to us is God’s will.” He kissed the top of her head, then took his Bible from his lap. The binding was worn, having been opened many times throughout the years. From within the pages, he drew out a paper and handed it to Gisela.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It wasn’t a paper, but a daisy pressed in between sheets of waxed paper. The flower looked like it might have been picked yesterday.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I gave a bouquet of daisies to your oma when we were courting. It was her favorite flower. They reminded her of God’s pureness and holiness. She told me that if you put them in water, they last forever. This one she took from the bunch and pressed it in her Bible. When she died, I slipped it in mine, in the same passage where she had it. I want you to take this. Put it in Isaiah chapter 43.”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v("“This is for me?” ")])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“Ja. When the road gets hard, I want you to remember the daisy. And the passage it is in.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Gisela clung to her grandfather, their tears mingling and dripping down their cheeks. A little piece of her heart tore away. How could she do this?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Opa released his hold on her. “It is time to go. Remember. ‘When thou passest through the waters, I will be with thee.’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Gisela nodded and kissed him on the cheek. With trembling fingers, she retrieved her English Bible from her suitcase, the one she had earned for good Sunday school attendance at their church in California. Flipping the pages, she located Isaiah 43. Tears blurred her vision so she couldn’t read the words. She placed the daisy between the pages and closed the brown leather cover.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Once outside, the women bundled the girls in the cart, wool blankets and bright quilts covering all but their button noses. Gisela pulled her daisy-studded scarf around her neck.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the bursts of light cast by the exploding bombs, Gisela became aware of the refugees filing past them, a stream of humanity headed toward safety. She set her attention behind her, to the house they were leaving. Her mother’s parents had lived here all their married lives, and she and her parents had come here each summer from the States.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For the last time, she crossed inside and stood in the hall. Closing her eyes, she allowed the memories to wash over her. She smelled Oma’s kitchen and the scent of her pink and yellow roses from the garden, felt the cool, smooth wood floors beneath her bare feet and the softness of the feather mattress.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She heard Margot’s laugh, her light snoring in the bed beside her, smelled the fragrance of her rose water.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v("She remembered how her opa’s mustache tickled her cheek when he kissed her good night, how he smelled like the pipe ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("tobacco he loved to smoke, how his big hand engulfed her little one as they wandered the streets of the city.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("The grandfather clock in the hall, well-oiled with beeswax, chimed the hour.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How many times had she and Margot lain in bed well into the depths of the night, listening to the clock toll each quarter hour? A few tears eeked from the corners of her eyes as she heard Opa’s bass, singing German folk songs to her, lulling her to sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nothing would ever be the same. She would never return to this house. All she would have left would be a handful of memories. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And a daisy tucked in her Bible.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60530fdd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter4.vue
// module id = 81
// module chunks = 0